module.exports = __webpack_public_path__ + "media/images/teacher/total-income-5a673a4792a5e0f64b42311390ce2f6b.png";